<template>
    <div class="privacy-policy-area">
        <div class="container">
            <div class="privacy-policy-content">
                <h2>Overview</h2>
                <p>At <strong>Meander Software</strong>, we are committed to delivering high-quality software solutions
                    and services. We aim for complete customer satisfaction and transparency in all our engagements.</p>

                <h4>1. Scope of This Policy</h4>
                <p>This policy applies to all services, software products, and digital solutions provided by Meander
                    Software. It outlines the circumstances under which refunds or corrections may be provided.</p>

                <h5>2. Service Satisfaction Guarantee</h5>
                <p>We strive to meet project requirements and deadlines as agreed in our contracts or proposals.</p>
                <ul>
                    <li>If you encounter issues with a delivered service, please contact us immediately.</li>
                    <li>Our team will review your concerns and work to correct any errors or shortcomings promptly.</li>
                </ul>
                <h5>3. Refunds</h5>
                <p>Refunds for digital services are limited and handled on a case-by-case basis.</p>
                <ul>
                    <li>Full refunds may be issued if the project or service was not delivered according to the agreed
                        scope.</li>
                    <li>Partial refunds may be considered if the service is partially completed or only certain
                        deliverables fail to meet specifications.</li>
                    <li>Refund requests must be submitted within 14 days of delivery of the service or product.</li>
                </ul>
                <h5>4. Non-Refundable Services</h5>
                <p>Certain services are non-refundable, including but not limited to:</p>
                <ul>
                    <li>Custom software development, once development has begun</li>
                    <li>Software licenses or subscriptions that have been activated</li>
                    <li>Consultation hours already delivered </li>
                </ul>

                <h5>5. How to Request a Refund</h5>
                <p>To request a refund or report issues:</p>
                <ol>
                    <li> Contact our support team at
                        <a href="mailto:contact@meander.software">contact@meander.software</a>.
                    </li>
                    <li>Provide your project details, invoice number, and reason for the refund request.</li>
                    <li>Our team will review and respond within 5 business days.</li>
                </ol>

                <h5>6. Modifications to This Policy</h5>
                <p>Meander Software reserves the right to update this Return & Refund Policy at any time. Updates will
                    be posted on this page with the revised effective date.</p>

                <h5>7. Contact Us</h5>
                <p>For questions regarding this Return & Refund Policy, please contact us:</p>
                <p>
                    Email:
                    <a href="mailto:contact@meander.software">contact@meander.software</a>
                </p>
                <p>
                    Phone:
                    <a href="tel:(+91) 80-9054-9054">(+91) 80-9054-9054</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReturnPolicy'
}
</script>